import anime from 'animejs';

// Rends anime disponible globalement
window.anime = anime;
export default anime;
